import {
  BrainIcon,
  BroadcastIcon,
  ChartLineIcon,
  ClockwiseArrowsIcon,
  DollarIcon,
  GameIcon,
  GearIcon,
  GiftIcon,
  GlobeIcon,
  HeartIcon,
  MultiPersonIcon,
  PieSliceIcon,
  PlugIcon,
  RepeatIcon,
  WifiIcon,
} from "../../assets/images/svgExports";
import { FaUsers } from "react-icons/fa6";
import { RiLightbulbFill, RiSettings4Fill } from "react-icons/ri";
import {
  PiMapTrifoldFill,
  PiShieldCheckFill,
  PiChartLineUpLight,
  PiUserCircleMinusFill,
  PiUserSwitchFill,
  PiLinkSimpleHorizontalLight,
  PiRocketLaunchFill,
  PiGitDiffFill,
  PiPulseBold,
  PiUsersFourFill,
  PiCpuFill,
  PiTreeStructureFill,
  PiHandTapFill,
} from "react-icons/pi";

const Light = RiLightbulbFill as React.ComponentType<{
  color?: string;
  size?: number;
}>;
const Users = FaUsers as React.ComponentType<{
  color?: string;
  size?: number;
}>;
const Map = PiMapTrifoldFill as React.ComponentType<{
  color?: string;
  size?: number;
}>;
const Sheild = PiShieldCheckFill as React.ComponentType<{
  color?: string;
  size?: number;
}>;
const Chart = PiChartLineUpLight as React.ComponentType<{
  color?: string;
  size?: number;
}>;
const UserMinus = PiUserCircleMinusFill as React.ComponentType<{
  color?: string;
  size?: number;
}>;

const UserCycle = PiUserSwitchFill as React.ComponentType<{
  color?: string;
  size?: number;
}>;
const HandPoint = PiHandTapFill as React.ComponentType<{
  color?: string;
  size?: number;
}>;
const Link = PiLinkSimpleHorizontalLight as React.ComponentType<{
  color?: string;
  size?: number;
}>;
const Settings = RiSettings4Fill as React.ComponentType<{
  color?: string;
  size?: number;
}>;
const Launch = PiRocketLaunchFill as React.ComponentType<{
  color?: string;
  size?: number;
}>;
const Optimize = PiGitDiffFill as React.ComponentType<{
  color?: string;
  size?: number;
}>;
const Users4 = PiUsersFourFill as React.ComponentType<{
  color?: string;
  size?: number;
}>;
const Pulse = PiPulseBold as React.ComponentType<{
  color?: string;
  size?: number;
}>;
const Cpu = PiCpuFill as React.ComponentType<{
  color?: string;
  size?: number;
}>;
const TreeStructure = PiTreeStructureFill as React.ComponentType<{
  color?: string;
  size?: number;
}>;
export const faqData = [
  {
    question: "What is Bridgetune?",
    answer:
      "Bridgetone is a B2B Software as a Service (SaaS) company specializing in user retention as a service. We partner with brands to design, build, and execute tailored user retention strategies and activities, often encompassing web application development and hosting.",
  },
  {
    question: "What is 'User Retention as a Service'?",
    answer:
      "It means we act as your dedicated retention partner. We don't just provide a tool; we offer a full-service solution including strategy consulting, developing and hosting engagement platforms (like promotional websites or micro-sites), and managing the operational aspects of user retention campaigns.",
  },
  {
    question: "What kind of results can Bridgetune deliver?",
    answer:
      "We help brands re-engage dormant users and increase the lifetime value of active users. ",
  },
  {
    question: "Which industries do you serve?",
    answer:
      "While our solutions are applicable across various B2B sectors, we have strong expertise working with large organizations in telecommunications, finance, e-commerce, and other industries where user lifecycle management and transaction volume are critical.",
  },
  {
    question:
      "Does Bridgetune build the websites and applications, or do you just provide the software?",
    answer:
      "We do both. We provide the underlying SaaS platform for managing retention activities and we offer full-stack development and hosting services for the user-facing websites or web apps.",
  },
  {
    question: "Where are the web apps hosted?",
    answer:
      "We provide enterprise-grade, secure, and scalable cloud hosting for all applications we develop, ensuring high availability and performance even during peak traffic events.",
  },
  {
    question: "How do you ensure data security and compliance?",
    answer:
      "Data security is paramount. We adhere to industry best practices, including robust encryption, access controls, and regular security audits. We are prepared to meet the specific compliance requirements (e.g., GDPR,  local data privacy laws) relevant to your industry and region.",
  },
  {
    question: "How does Bridgetune integrate with our existing systems?",
    answer:
      "Our platform is designed for flexible integration using standard APIs (Application Programming Interfaces). We can connect with your existing CRM, marketing automation platforms, and internal data warehouses to ensure a unified view of the user and seamless campaign execution.",
  },
  {
    question: "How can we start working with Bridgetune?",
    answer:
      "You can contact our sales team through the 'Request a Demo' form on our website or by emailing ‘ BRIDGETUNE EMAIL ADDRESS’. We begin with a discovery session to understand your specific retention challenges and business objectives.",
  },
  {
    question: "What is your pricing model?",
    answer:
      "Our pricing is based on a B2B SaaS model, typically involving a tiered subscription fee based on the scope of services, the number of active users/campaigns, and the level of customization and support required. We offer custom quotes after the initial scoping phase.",
  },
  {
    question: "Is there a minimum contract length?",
    answer:
      "We are flexible and can discuss pilot programs or shorter terms depending on the project.",
  },
];

export const ecosystemData = [
  {
    title: "Customer Engagement And Automation",
    blocks: [
      {
        title: "Plug-In Tech Platform",
        description:
          "Seamlessly Integrate With Our Ecosystem. Plug In Once, Access All Capabilities Instantly.",
        icon: <PlugIcon color="#2C73DB" />,
      },
      {
        title: "Data & Analytics Layer",
        description:
          "Consumer Insights, Segmentation, Predictive Modeling, And Churn-Risk Detection Powered By AI.",
        icon: <PieSliceIcon />,
      },
      {
        title: "Omni-Channel Orchestration",
        description:
          "Personalized Experiences Across Mobile, Web, Apps, SMS/USSD, Push Notifications, And More.",
        icon: <BroadcastIcon />,
      },
      {
        title: "Telecom VAS Capabilities",
        description:
          "Licensed VAS Provider With Deep Integration Into African Telecom Ecosystems.",
        icon: <WifiIcon />,
      },
    ],
  },
  {
    title: "Data-Driven Revenue Optimization",

    blocks: [
      {
        title: "ML-Powered Predictive Analytics",
        description:
          "Ensemble learning models for purchase propensity, churn risk, and lifetime value prediction.",
        icon: <BrainIcon />,
      },
      {
        title: "Revenue Intelligence Platform",
        description:
          "Advanced Recommendation Engine For Upsell/Cross-Sell Opportunities And Pricing Optimization.",
        icon: <ChartLineIcon />,
      },
      {
        title: "Dynamic Pricing & Optimization",
        description:
          "Algorithmic Pricing Engine With Demand Elasticity Modeling And Yield Optimization.",
        icon: <DollarIcon />,
      },
      {
        title: "Automated Retention Engine",
        description:
          "Intelligent Win-Back System Using Survival Analysis And Customer Health Scores.",
        icon: <ClockwiseArrowsIcon />,
      },
    ],
  },
  {
    title: "Retention & Loyalty Management",

    blocks: [
      {
        title: "Programmable Loyalty Engine",
        description:
          "Configurable Rules Engine With Multi-Tier Progression And Blockchain/Distributed Ledger Support.",

        icon: <GearIcon />,
      },
      {
        title: "Gamification Framework",
        description:
          "Behavioral Psychology-Driven Engagement With Challenges, Leaderboards, And Achievements.",
        icon: <GameIcon />,
      },
      {
        title: "Community Engagement Platform",
        description:
          "Social Layer With Referral Mechanics, Viral Loop Optimization, And Network Effect Analytics.",
        icon: <MultiPersonIcon />,
      },
      {
        title: "Personalized Rewards Marketplace",
        description:
          "AI-Driven Rewards Recommendation With Extensive Merchant And Partner Integration APIs.",
        icon: <GiftIcon />,
      },
    ],
  },
];

export const cardData = [
  {
    title: "Engagement",
    description:
      "Reach customers where they are with personalized campaigns that spark attention and inspire action.",
    icon: <GlobeIcon />,
    isBlue: false,
  },
  {
    title: "Retention",
    description:
      "Keep Customers Coming Back With Data-Driven Strategies That Turn First-Time Users Into Loyal Fans.",
    icon: <RepeatIcon />,
    isBlue: true,
  },
  {
    title: "Loyalty",
    description:
      "Go beyond transactions by rewarding customers in meaningful ways and building genuine brand advocates.",
    icon: <HeartIcon />,
    isBlue: false,
  },
];
export const africanMarketFeatures = [
  {
    title: "Built for Africa",
    description:
      "Deep understanding of African consumer behavior, culture, and market dynamics across 15+ countries.",
    icon: <Map color="#2C73DB" size={25} />,
  },
  {
    title: "Licensed VAS Provider",
    description:
      "Officially licensed in telecom ecosystems, ensuring compliance and seamless integration.",
    icon: <Sheild color="#2C73DB" size={25} />,
  },
  {
    title: "Local Innovation",
    description:
      "Solutions designed specifically for African markets, not adapted from Western models.",
    icon: <Light color="#2C73DB" size={25} />,
  },
  {
    title: "50M+ Consumers",
    description:
      "Proven track record reaching millions of African consumers across diverse segments.",
    icon: <Users color="#2C73DB" size={25} />,
  },
];
export const whyBridgetunePillars = [
  {
    title: "Grow Revenue",
    description:
      "Unlock new consumer interactions, upsells, and loyalty opportunities that drive sustainable revenue growth.",
    icon: <Chart size={25} color="#2C73DB" />,
  },
  {
    title: "Reduce Churn",
    description:
      "Understand, engage, and retain customers through data-driven insights and personalized journeys.",
    icon: <UserMinus size={25} color="#2C73DB" />,
  },
  {
    title: "Drive Engagement",
    description:
      "Create meaningful consumer interactions across all channels with technology, data, and gamification.",
    icon: <UserCycle size={25} color="#2C73DB" />,
  },
  {
    title: "Increase NPS",
    description:
      "Build consumer-centric experiences that delight your customers and boost Net Promoter Scores.",
    icon: <HandPoint size={25} color="#2C73DB" />,
  },
];
export const howItWorksSteps = [
  {
    step: 1,
    title: "Connect",
    description:
      "Plug your brand into the Bridgetune ecosystem with our seamless API integration.",
    icon: <Link size={25} color="#2C73DB" />,
  },
  {
    step: 2,
    title: "Configure",
    description:
      "Activate the features you need, from data analytics to gamification and loyalty rewards.",
    icon: <Settings size={25} color="#2C73DB" />,
  },
  {
    step: 3,
    title: "Launch",
    description:
      "Deploy consumer-centric campaigns and experiences tailored to African markets.",
    icon: <Launch size={25} color="#2C73DB" />,
  },
  {
    step: 4,
    title: "Optimize",
    description:
      "Monitor real-time insights, measure outcomes, and continuously improve performance.",
    icon: <Optimize size={25} color="#2C73DB" />,
  },
];
export const platformFeatures = [
  {
    text: "Real-time analytics and insights dashboard",
    icon: <Pulse size={25} color="#2C73DB" />,
  },
  {
    text: "Unified customer engagement across all channels",
    icon: <Users4 size={25} color="#2C73DB" />,
  },
  {
    text: "AI-driven revenue optimization tools",
    icon: <Cpu size={25} color="#2C73DB" />,
  },
  {
    text: "Seamless integration with existing systems",
    icon: <TreeStructure size={25} color="#2C73DB" />,
  },
];
